import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";

import DashboardPage from "@/pages/Dashboard";
import ProjectsPage from "@/pages/Projects";
import CamerasPage from "@/pages/Cameras";
import UploadPage from "@/pages/Upload";
import FilmsPage from "@/pages/Films";
import EventsPage from "@/pages/Events";
import LiveViewPage from "@/pages/LiveView";
import UsersPage from "@/pages/Users";
import MembersPage from "@/pages/Members";
import SettingsPage from "@/pages/Settings";
import CloudSyncPage from "@/pages/CloudSync";
import NasArchivePage from "@/pages/NasArchive";

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } },
});

function App() {
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <Toaster richColors closeButton position="top-right" />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/proiecte" element={<ProjectsPage />} />
              <Route path="/camere" element={<CamerasPage />} />
              <Route path="/upload" element={<UploadPage />} />
              <Route path="/filme" element={<FilmsPage />} />
              <Route path="/evenimente" element={<EventsPage />} />
              <Route path="/live" element={<LiveViewPage />} />
              <Route path="/utilizatori" element={<UsersPage />} />
              <Route path="/membri" element={<MembersPage />} />
              <Route path="/setari" element={<SettingsPage />} />
              <Route path="/cloud-sync" element={<CloudSyncPage />} />
              <Route path="/arhiva-nas" element={<NasArchivePage />} />
              <Route path="*" element={<DashboardPage />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
